// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__301Km","content":"GlobalSearch_content__B5uM_"};